import { render, staticRenderFns } from "./TokenExpirationTimer.vue?vue&type=template&id=12e9dfaa&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TokenExpirationTimer.vue?vue&type=script&async=true&lang=js&"
export * from "./TokenExpirationTimer.vue?vue&type=script&async=true&lang=js&"
import style0 from "./TokenExpirationTimer.vue?vue&type=style&index=0&id=12e9dfaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9dfaa",
  null
  
)

export default component.exports